export const WARM: Record<WarmScreenNames, string> = {
	W0: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>WARM</td>
                    <td>W1</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>INTRO</strong>
            </p>
        </div>
    `,

	W1: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>If answered "Yes"</td>
                    <td>WARM</td>
                    <td>W2</td>
                </tr>
                <tr>
                    <td>If answered "No"</td>
                    <td>ABOUT_YOUR_DOGS</td>
                    <td>Q1</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>MANDATORY</strong>
            </p>
        </div>
    `,

	W2: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>If answered "Yes"</td>
                    <td>WARM</td>
                    <td>W2_2</td>
                </tr>
                <tr>
                    <td>If answered "No"</td>
                    <td>WARM</td>
                    <td>W2_1</td>
                </tr>
                <tr>
                    <td>If answered "Prefer not to say"</td>
                    <td>ABOUT_YOUR_DOGS</td>
                    <td>Q1</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>MANDATORY</strong>
            </p>
        </div>
    `,

	W2_1: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>WARM</td>
                    <td>W3</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,

	W2_2: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>WARM</td>
                    <td>W3</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>Shows dog profile</p>
        </div>
    `,

	W3: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>If they still have warm dog and answered "Yes"</td>
                    <td>WARM</td>
                    <td>W4_1</td>
                </tr>
                <tr>
                    <td>If they still have warm dog and answered "No"</td>
                    <td>ABOUT_YOUR_DOGS</td>
                    <td>Q6</td>
                </tr>
                <tr>
                    <td>If they do not have warm dog and answered "Yes"</td>
                    <td>ABOUT_YOUR_DOGS</td>
                    <td>Q1</td>
                </tr>
                <tr>
                    <td>If they do not have warm dog and answered "No"</td>
                    <td>THOUGHTS_ON_DOGS</td>
                    <td>E1</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>MANDATORY</strong>
            </p>
        </div>
    `,

	W4_1: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>If no new dogs (0) and total dogs is 1</td>
                    <td>ABOUT_YOUR_DOGS</td>
                    <td>Q6</td>
                </tr>
                <tr>
                    <td>If no new dogs (0) and total dogs > 1</td>
                    <td>WARM</td>
                    <td>W4_3</td>
                </tr>
                <tr>
                    <td>If they have new dogs</td>
                    <td>WARM</td>
                    <td>W4_2</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>MANDATORY</strong>
            </p>
        </div>
    `,

	W4_2: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>If total dogs (new + warm) >= 5</td>
                    <td>ABOUT_YOUR_DOGS</td>
                    <td>Q6</td>
                </tr>
                <tr>
                    <td>If total new dogs + warm = total dogs</td>
                    <td>ABOUT_YOUR_DOGS</td>
                    <td>Q3</td>
                </tr>
                <tr>
                    <td>Otherwise (space for more dogs)</td>
                    <td>WARM</td>
                    <td>W4_3</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,

	W4_3: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>If warm dog is newest (index 1)</td>
                    <td>ABOUT_YOUR_DOGS</td>
                    <td>Q6</td>
                </tr>
                <tr>
                    <td>Otherwise</td>
                    <td>ABOUT_YOUR_DOGS</td>
                    <td>Q3</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,
};
